import { gql } from "@apollo/client";

export const WALL_POST_FIELDS = gql`
  fragment wallPostFields on WallPost {
    _id
    message
    category
    tags
    pinned
    pinnedAt
    editedAt
    createdAt
    author {
      _id
      name
      avatar
    }
    employees {
      _id
      givenName
      surName
      referenceNumber
    }
    brokers {
      name
      company {
        _id
        displayName
      }
    }
    contacts {
      name
      employee {
        _id
        givenName
        surName
      }
    }
    mentions {
      _id
      name
      avatar
    }
    complaint {
      _id
      subject
      status
    }
    reactions {
      type
      user {
        _id
        name
      }
    }
    comments {
      _id
      message
      createdAt
      editedAt
      author {
        _id
        name
        avatar
      }
    }
  }
`;

export const GET_WALL_OFFICE_USERS = gql`
  query WallOfficeUsers {
    wallOfficeUsers {
      _id
      name
      avatar
    }
  }
`;

export const WALL_SEARCH_EMPLOYEES = gql`
  query WallSearchEmployees($searchText: String) {
    wallSearchEmployees(searchText: $searchText) {
      _id
      givenName
      surName
      referenceNumber
    }
  }
`;

export const WALL_SEARCH_COMPANIES = gql`
  query WallSearchCompanies($searchText: String) {
    wallSearchCompanies(searchText: $searchText) {
      _id
      displayName
    }
  }
`;

export const GET_WALL_POSTS = gql`
  ${WALL_POST_FIELDS}
  query WallPosts(
    $skip: Int!
    $take: Int!
    $category: WallCategory
    $employeeId: String
    $brokerCompanyId: String
    $authorId: String
    $tag: String
    $searchText: String
    $complaintId: String
  ) {
    wallPosts(
      skip: $skip
      take: $take
      category: $category
      employeeId: $employeeId
      brokerCompanyId: $brokerCompanyId
      authorId: $authorId
      tag: $tag
      searchText: $searchText
      complaintId: $complaintId
    ) {
      totalCount
      posts {
        ...wallPostFields
      }
    }
  }
`;
